import { Component, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PermitDirective } from '../../directives/permit.directive';
import { LogoutDirective } from '../../directives/logout.directive';
import { environment } from '@environments/environment';

@Component({
  selector: 'lv-site-nav',
  templateUrl: 'site-nav.component.html',
  styleUrls: ['site-nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, TranslateModule, PermitDirective, LogoutDirective]
})
export class SiteNavComponent {
  adminUrl = `${environment.apiBase}admin`;
}
